// Written in Object Style because of usage in Select component
import { Theme } from 'src/ui/style/Theme'
import { css } from 'src/ui/style/css'

export const inputBorder = (roundInputStyle?: boolean) => (th: Theme) => ({
    border: roundInputStyle
        ? `3px solid ${th.colors.tertiary}`
        : `1px solid ${th.colors.primary}`,
    borderRadius: roundInputStyle
        ? th.borderRadius.secondary
        : th.borderRadius.primary,
    '&:hover': {
        borderColor: th.colors.tertiary
    }
})

export const wordWrap = () => css`
    /*
    So newlines can be used from translations 
    We have to use 'pre-line' because of safari
    https://www.youtrack.software/issue/BOXY-389
    */
    white-space: pre-line;
`

export const iconStyle = (clickable = false) => (th: Theme) =>
    css`
        color: ${th.colors.tertiary};
        font-size: ${th.iconToTextSizeRatio};
        cursor: ${clickable ? 'pointer' : 'inherit'};
    `

export const sticky = (zIndex: number) => css`
    // Position of this sub-menu is fixed below main menu
    z-index: ${zIndex};
    position: sticky;
`

export const grayscale = () =>
    css`
        filter: grayscale(100%);
    `

export const firstMonthFreeBadge = (absolute = false) => (th: Theme) => css`
    text-align: center;
    position: ${absolute ? 'absolute' : 'initial'};
    bottom: ${absolute ? th.spacing.sm : 'initial'};
    background-color: ${th.colors.eyeCatcher};
    color: ${th.colors.white};
    padding: ${th.spacing.sm};
    border-radius: ${th.borderRadius.primary};
    font-size: ${th.fontSize.xs};
    font-weight: bold;
`

export const boxSizeCard = (enabled = true) => (th: Theme) => css`
    padding: ${th.spacing.md};
    border: 1px solid rgba(0, 178, 238, 0.2);
    background-color: rgba(0, 178, 238, 0.05);
    cursor: ${enabled ? 'pointer' : 'default'};
    display: flex !important;
    flex-direction: row !important;
`
